import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=bcb850c4"
import script from "./Permissions.js?vue&type=script&lang=js&external"
export * from "./Permissions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports